import React from 'react';
import {
    Paper,
    Typography
} from 'material-ui';
import { withStyles } from 'material-ui/styles';
import { translate } from 'react-i18next';
import { Grid } from 'material-ui';
import ObservationsChecksRender from './ObservationsChecksRender';

const styles = theme => ({
    //    root: theme.mixins.gutters({
    //     paddingTop: 16,
    //     paddingBottom: 16,
    //     marginTop: theme.spacing.unit * 3,
    //   }),
    bookingTitle: {
        color: theme.palette.primary.main,
        padding: '20px 0 20px 25px',
        fontWeight: 'bold',
        fontSize: '1.2rem',
        borderLeft: '2px solid ' + theme.palette.primary.main
    },
    paperFrame: {
        margin: '20px 0px',
        height: '100%'
    }

});

class ReservationObservationsRender extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            observations: ''
        };
    }

    formatObservations = (observations) => {
        let obs = ['... '];
        try {
            if (observations && typeof observations === 'string') {
                obs = observations.split(/\r*\n+/);
            } else if (Array.isArray(observations)) {
                obs = observations;
            }
        } catch (e) {
            //console.log(e);
            obs = ['... '];
        }
        return obs.filter(o => String(o).trim() !== '').map(o => <li id={o}>{o}</li>);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.reservation && nextProps.reservation.hotelObservations && nextProps.reservation.hotelObservations.length) {
            const { hotelObservations } = nextProps.reservation;
            let obs = [];
            if (JSON.parse(localStorage.getItem('updatedObservations'))) {
                obs = JSON.parse(localStorage.getItem('updatedObservations'));
            } else {
                obs = hotelObservations && hotelObservations.length && hotelObservations.find(val => val.id === 1) ? hotelObservations.find(val => val.id === 1).description : '';
            }
            this.setState({ observations: obs });
        }
    }    


    render() {
        const { classes, t, reservation } = this.props;
        return (
            <Paper className={classes.paperFrame}>
                <Typography className={classes.bookingTitle}>
                    {t('CONFIRM_BOOKING.HOTEL_ITEMS_OBSERVATIONS')}
                </Typography>

                <div>
                    {reservation && reservation.type !== 'DirectionsBus' &&
                        <ObservationsChecksRender {...this.props} viewOnlyMode={true} />
                    }
                    <div style={{ marginBottom: 20, marginTop: 20 }}>
                        <Typography component="ul" style={{ listStyleType: 'none', padding: 0, whiteSpace: 'break-spaces' }}>
                            {reservation && reservation.type === 'DirectionsBus' && reservation.observationsProveedor && reservation.observationsProveedor.length ? reservation.observationsProveedor[0] : this.state.observations}
                        </Typography>
                    </div>
                    {reservation && reservation.type !== 'DirectionsBus' &&
                        <Typography className="special-request-text">
                            {t('CONFIRM_BOOKING.SPECIAL_REQUESTS')}
                        </Typography>
                    }
                </div>
            </Paper>
        );
    }
}

export default translate('translations')(withStyles(styles)(ReservationObservationsRender));



// WEBPACK FOOTER //
// ./src/components/Reservation/ReservationObservationsRender.js